
import { defineComponent, PropType } from "vue";
import { RecordIdentifier } from "@/data/global";
import ContactFormRegion from "@/components/ContactFormRegion.vue";

declare interface ContactFormRegionModalData {
    shownLocal: boolean,
}

export default defineComponent({
    name: 'ContactFormRegionModal',
    components: {
        ContactFormRegion,
    },
    emits: [
        'close',
    ],
    props: {
        regionId: {
            type: [Number] as PropType<RecordIdentifier>,
            required: true,
        },
        shown: {
            type: Boolean,
            required: true,
        },
    },
    data(): ContactFormRegionModalData {
        return {
            shownLocal: true,
        };
    },
    computed: {

    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
    },
    watch: {
        shown: {
            handler(val) {
                this.shownLocal = val;
            },
            immediate: true,
        },
    },
});
